var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageError',{attrs:{"code":_vm.error.statusCode,"message":_vm.error.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }